const rules = {
  // required: (value) => !!value || 'Required.'
  // required rule is disabled
  required: value => true,
}

export default rules
